import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Sidebar = (props) => {
    const { t } = useTranslation();
    const pages = [
        { title: t('dicePage'), link: 'dice' },
        { title: t('cardPage'), link: 'card' },
        { title: t('hotPage'), link: 'hot' },
        { title: t('neverPage'), link: 'never' },
        { title: t('conversationPage'), link: 'conversation' },
        { title: 'Blog', link: 'blog' }
    ];
    return (
        <div ref={props.refProp} className="sidebar">
            <ul className="d-flex flex-column gap-3" style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                <li className="d-flex justify-content-between align-items-center" style={{ marginBottom: '1rem' }}>
                    <Link to="/" style={{ color: 'black', fontSize: '1.25rem', fontWeight: '600', textDecoration: 'none' }}>
                        Kamadice
                    </Link>
                    <button
                        style={{ 
                            border: 'none', 
                            backgroundColor: 'transparent', 
                            fontSize: '1.5rem',
                            cursor: 'pointer',
                            minWidth: '44px',
                            minHeight: '44px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            touchAction: 'manipulation',
                            padding: 0
                        }}
                        onClick={() => props.setOpenSidebar(false)}
                        aria-label="Close menu"
                    >
                        ×
                    </button>
                </li>
                {pages.map((item, idx) => {
                    return (
                        <li key={idx} style={{ margin: 0 }}>
                            <Link
                                onClick={() => {
                                    props.setOpenSidebar(false);
                                }}
                                to={`/${item.link}`}
                                style={{ 
                                    color: 'black', 
                                    textDecoration: 'none',
                                    display: 'block',
                                    padding: '0.75rem 0.5rem',
                                    minHeight: '44px',
                                    fontSize: '1.1rem',
                                    touchAction: 'manipulation',
                                    borderRadius: '0.25rem',
                                    transition: 'background-color 0.2s'
                                }}
                                onMouseEnter={(e) => {
                                    if (window.matchMedia('(hover: hover)').matches) {
                                        e.currentTarget.style.backgroundColor = '#f0f0f0';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = 'transparent';
                                }}
                            >
                                {item.title}
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
export default Sidebar;
